import { render, staticRenderFns } from "./hero-al-bronzo-cmp.vue?vue&type=template&id=2fe58b6a&scoped=true"
import script from "./hero-al-bronzo-cmp.vue?vue&type=script&lang=js"
export * from "./hero-al-bronzo-cmp.vue?vue&type=script&lang=js"
import style0 from "./hero-al-bronzo-cmp.vue?vue&type=style&index=0&id=2fe58b6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe58b6a",
  null
  
)

export default component.exports